export const isClinro = process.env.REACT_APP_CLINRO === 'true';
